<template>
  <div>
    <!-- BOC:[error] -->
    <AError :api="api"></AError>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>New Institution</v-card-title>
        <v-card-text>
          <template>
            <FormInput :value="form['institutionName']" @input="form['institutionName'] = $event" />
          </template>
          <template>
            <FormInput :value="form['institutionTown']" @input="form['institutionTown'] = $event" />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import FormInput from "@/components/Moderator/Application/Institution/FormInput";

import { mapState } from "vuex";
export default {
  props: ["data", "callbackSuccess"],
  components: {
    FormInput,
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[form]
    form: {
      id: null,
      institutionName: null,
      institutionTown: null,
    },
    fields: [],
    rules: {},
    //EOC
  }),

  created() {
    this.form.institutionName = this.data.institutionName
    this.form.institutionTown = this.data.institutionTown
    this.form.id = this.$route.params.id
    //BOC:[api]
    this.api.url = `${this.$api.servers.sso}/api/v1/en/moderator/application/approve`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    //BOC:[form]
    validate() {
      //this.api.callbackReset();
      if (this.$refs.form.validate()) {
        this.submit();
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
    //EOC
  },
};
</script>

<style>
</style>